import React from 'react'
import { translate } from 'react-i18next'
const AsideListItem = ({t, item}) => (
	<li className="mb-2">
		<a href={item.url} title={item.title} download>{item.title}</a>
	</li>
)
export default translate("translations")(AsideListItem)